<template>
  <el-dialog
    class="dialog-container"
    :title="title"
    :visible.sync="dialogVisible"
    append-to-body
    :width="dialogStatus == 'check' ? '750px !important' : ''"
  >
    <el-descriptions :column="2" border v-if="dialogStatus == 'check'">
      <el-descriptions-item label="活动名称" :span="2">{{
        form.activityName
      }}</el-descriptions-item>
      <el-descriptions-item label="活动描述" :span="2">{{
        form.activityDescription
      }}</el-descriptions-item>
      <el-descriptions-item label="金额">{{
        form.amount
      }}</el-descriptions-item>
      <el-descriptions-item label="币种">
        {{ form.currency }}
      </el-descriptions-item>
      <el-descriptions-item label="状态">
        <span v-if="form.status == 0" class="warnColor">未开始</span>
        <span v-if="form.status == 1" class="successColor">进行中</span>
        <span v-if="form.status == 2" style="color: #909399">已结束</span>
      </el-descriptions-item>
      <el-descriptions-item label="有效期">
        {{ form.dateRange.join(" ~ ") }}
      </el-descriptions-item>
      <el-descriptions-item label="创建人">{{
        form.creator
      }}</el-descriptions-item>
      <el-descriptions-item label="创建时间">
        {{
          form.createTime ? form.createTime.replace("T", " ") : form.createTime
        }}
      </el-descriptions-item>
    </el-descriptions>
    <el-form
      v-if="dialogStatus !== 'check'"
      ref="form"
      :model="form"
      :rules="rules"
      label-width="120px"
      v-loading="formLoading"
    >
      <el-form-item label="活动名称" prop="activityName">
        <el-input v-model="form.activityName" placeholder="请输入活动名称" />
      </el-form-item>
      <el-form-item label="活动描述" prop="activityDescription">
        <el-input
          v-model="form.activityDescription"
          type="textarea"
          :rows="4"
          placeholder="请输入活动描述"
          maxlength="200"
          show-word-limit
        />
      </el-form-item>
      <el-form-item label="金额" prop="amount">
        <el-input-number
          v-model="form.amount"
          :controls="false"
          :precision="2"
          placeholder="请输入金额"
          class="number-input"
        ></el-input-number>
      </el-form-item>
      <el-form-item label="币种" prop="currency">
        <el-select
          v-model="form.currency"
          placeholder="请选择币种"
          filterable
          clearable
        >
          <el-option label="CNY" :value="0"></el-option>
          <el-option label="USD" :value="1"></el-option>
          <el-option label="EUR" :value="2"></el-option>
          <el-option label="GBP" :value="3"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="有效期" prop="dateRange">
        <el-date-picker
          v-model="form.dateRange"
          value-format="yyyy-MM-dd"
          type="daterange"
          range-separator="-"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>
    </el-form>
    <div
      slot="footer"
      class="dialog-footer-button"
      v-if="dialogStatus !== 'check'"
    >
      <el-button type="primary" :loading="saveLoading" @click="handleSave">
        确定
      </el-button>
      <el-button plain @click="dialogVisible = false">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { kdactivitySupportAdd, kdactivitySupportEdit } from "@/api/seek";

export default {
  components: {},
  dicts: [],
  data() {
    return {
      title: "",
      dialogVisible: false,
      formLoading: false,
      saveLoading: false,
      form: this.getForm(),
      dialogStatus: "",
      rules: {
        activityName: [
          {
            required: true,
            message: "活动名称不能为空",
            trigger: ["blur", "change"],
          },
        ],
        activityDescription: [
          {
            required: true,
            message: "活动描述不能为空",
            trigger: ["blur", "change"],
          },
        ],
        amount: [
          {
            required: true,
            message: "金额不能为空",
            trigger: ["blur", "change"],
          },
        ],
        currency: [
          {
            required: true,
            message: "币种不能为空",
            trigger: ["blur", "change"],
          },
        ],
        dateRange: [
          {
            required: true,
            message: "有效期不能为空",
            trigger: ["blur", "change"],
          },
        ],
      },
    };
  },
  methods: {
    init(title, data = {}) {
      if (title == "查看") {
        this.dialogStatus = "check";
        this.title = "活动详情";
      } else {
        this.dialogStatus = "";
        this.title = title + "活动";
      }
      this.dialogVisible = true;
      this.formLoading = true;
      this.form = this.getForm(data);
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      });
      this.formLoading = false;
    },
    getForm(data = {}) {
      return {
        id: data.activityId || data.id || "",
        activityName: data.activityName || "",
        activityDescription: data.activityDescription || "",
        amount: data.amount || undefined,
        currency: typeof data.currency === 'string' ? parseInt(data.currency) : data.currency,
        status: data.status,
        creator: data.creator,
        createTime: data.createTime,
        dateRange:
          data.validFrom && data.validTo ? [data.validFrom, data.validTo] : [],
      };
    },
    handleSave() {
      this.$refs.form.validate(async (valid) => {
        if (!valid) {
          return;
        }
        this.saveLoading = true;
        try {
          const submitData = JSON.parse(JSON.stringify(this.form));
          if (submitData.dateRange && submitData.dateRange.length === 2) {
            submitData.validFrom = submitData.dateRange[0];
            submitData.validTo = submitData.dateRange[1];
          }
          delete submitData.dateRange;
          if (submitData.id) {
            submitData.activityId = submitData.id;
          }
          delete submitData.id;
          let res = {};
          if (submitData.activityId) {
            res = await kdactivitySupportEdit({ data: submitData });
          } else {
            res = await kdactivitySupportAdd({ data: submitData });
          }
          if (res.status == 0) {
            this.dialogVisible = false;
            this.$DonMessage.success("操作成功！");
            this.$emit("success");
          } else {
            this.$DonMessage.error(res.message);
          }
        } catch (error) {
          console.error(error);
        }
        this.saveLoading = false;
      });
    },
  },
};
</script>
